import { useSession } from "@outschool/ui-auth";
import { useEffect } from "react";

import useExperiment from "./useExperiment";

/**
 * PRD: https://docs.google.com/document/d/1LBFUigRXY5uO2fv9SnZkkp-YcPS4KR8Nf-Ze5wz5rC0
 */
export default function useManualCouponExperiment() {
  const { currentUserHasLoaded, currentUser, isEsaSession } = useSession();
  const { variant, trigger } = useExperiment("ManualCouponExperiment");

  useEffect(() => {
    // Wait for relevant data to be available.
    // Ignore ESA users (either in ESA session or with ESA memberships).
    // Ignore returning members, who will not see coupons anyway.
    if (
      !currentUserHasLoaded ||
      isEsaSession ||
      currentUser?.hasEsaMembership ||
      currentUser?.hasEverSubscribed
    ) {
      return;
    }
    // Trigger the experiment
    trigger();
  }, [
    trigger,
    currentUserHasLoaded,
    currentUser?.hasEsaMembership,
    currentUser?.hasEverSubscribed,
    isEsaSession,
  ]);

  return {
    isManualCouponExperiment: variant === "treatment",
  };
}
